import React, { Component } from 'react';
import { connect } from 'react-redux';
import _flatten from 'lodash/flatten';
import _flatMap from 'lodash/flatMap';
import _uniq from 'lodash/uniqWith';

import ChoiceWidget from '../ChoiceWidget';
import AlphaSelector from '../AlphaSelector';
import ColorPicker from '../ColorPicker';

import { addNewSticker, setStickerCategory, editObject, searchSticker, resetStickerKeyword } from "../../actions";

class StickerNew extends Component {

  scrollDivRef = React.createRef();
  composing = false

  state = {
    dummy: 0
  }

  constructor(props) {
    super(props);
    this.handleNewSticker = this.handleNewSticker.bind(this);
    this.handleSelectCategory = this.handleSelectCategory.bind(this);
    this.changeKeyword = this.changeKeyword.bind(this);
    this.handleComposition = this.handleComposition.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillUnmount() {
    //console.log(this.scrollDivRef);
    //console.log('ScrollTop is ' + this.scrollDivRef.current.scrollTop);
    this.props.onScrollChanged(this.scrollDivRef.current.scrollTop);
  }

  componentDidMount() {
    this.scrollDivRef.current.scrollTop = this.props.scrollTop;
  }

  handleNewSticker(sticker) {
    return () => {
      this.props.addNewSticker(sticker);
    }
  }

  handleSelectCategory(category) {
    this.props.setStickerCategory(category);
    this.setState({dummy: this.state.dummy + 1});
  }

  changeKeyword(e) {
    if (e.target.value === "") {
      this.props.resetStickerKeyword();
    } else {
      this.props.searchSticker(e.target.value);
    }
  }

  handleComposition(e) {
    if (e.type === 'compositionend') {
      setTimeout(() => {this.composing = false}, 100);
    } else {
      this.composing = true
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      if (this.composing) { return }

      this.changeKeyword(e);
    }
  }

  render() {
    let stickers;

    if (this.props.stickers.keyword) {
      stickers = this.props.stickers.searchResult;
    } else if (!this.props.stickers.currentCategory) {
      //console.info('Category is null');
      stickers = _flatMap(this.props.stickers.categories, (category) => category.stickers);
      stickers = _uniq(stickers, (a, b) => a.id === b.id);
      //console.log(_uniq([1,1,2,2], (a, b) => a === b));
    } else {
      //console.info('Category is selected');
      stickers = this.props.stickers.currentCategory.stickers;
    }

    return (
      <div ref={this.scrollDivRef} className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        <div className="t-container-sidebar-content">
          <h3>スタンプの追加</h3>

          <input
            type="text"
            className="form-control form-control-no-margin"
            placeholder="キーワード検索..."
            onKeyDown={this.handleKeyDown}
            defaultValue={this.props.stickers.keyword}
          />

          <div className="sticky-container">
            <ChoiceWidget
              choices={this.props.stickers.categories}
              data={this.props.stickers.currentCategory}
              onSelect={this.handleSelectCategory}
              placeholder={{
                renderLabel: () => (<span><small className="text-muted">カテゴリー:</small> 全て</span>),
                renderChoice: () => { return '全て'; }
              }}
              renderLabel={(data) => {
                return <span><small className="text-muted">カテゴリー:</small> {data.name}</span>;
              }}
              renderChoice={(data) => {
                return data.name;
              }}
              comparator={(choice, data) => {
                return data && (choice.id === data.id);
              }}
            />
          </div>

          <div className="t-container-sticker-list" data-dummy={this.state.dummy}>
            {stickers.map((sticker) => {
              return (
                <span
                  key={sticker.id}
                  className="t-container-sticker-cell"
                  style={{backgroundImage: 'url(' + sticker.image + ')'}}
                  onClick={this.handleNewSticker(sticker)}
                />
              );
            })}
          </div>
        </div>
      </div>
    )
  }
}

class StickerPane extends Component {

  state = {
    scrollTop: 0
  }

  constructor(props) {
    super(props);
    this.changeColor = this.changeColor.bind(this);
    this.changeOpacity = this.changeOpacity.bind(this);
    this.renderColorPicker = this.renderColorPicker.bind(this);
  }

  changeColor(color) {
    this.props.editObject(this.props.sidebar.object.id, {
      fill: color.hex
    })
  }

  changeOpacity(opacity) {
    this.props.editObject(this.props.sidebar.object.id, {
      opacity: opacity
    })
  }

  renderColorPicker(object) {
    if (object.src.match(/\.svg$/)) {
      return (
        <div>
          <ColorPicker value={object.props.fill || '#000000'} name="colorpicker-2" onChange={this.changeColor}/>
        </div>
      );
    } else {
      return (
        <div className="fallback">
          このスタンプは色を変更できません
        </div>
      );
    }
  }

  renderEdit(object) {
    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        <div className="t-container-sidebar-content">
          <h3>スタンプの編集</h3>

          {this.renderColorPicker(object)}
          <AlphaSelector value={object.props.opacity || 1.0} onChange={this.changeOpacity}/>
        </div>
      </div>
    )
  }

  render() {
    if (this.props.sidebar.object && this.props.sidebar.object.type === 'sticker') {
      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];

      if (object) {
        return this.renderEdit(object);
      }
    }

    return <StickerNew onScrollChanged={(value) => { this.setState({scrollTop: value}); }} scrollTop={this.state.scrollTop} />
  }
}

StickerNew = connect(f => f, {addNewSticker, setStickerCategory, editObject, searchSticker, resetStickerKeyword})(StickerNew);
StickerPane = connect(f => f, {addNewSticker, setStickerCategory, editObject, searchSticker, resetStickerKeyword})(StickerPane);

export default StickerPane;


// WEBPACK FOOTER //
// ./src/components/Sidebar/StickerPane.js